<template>
  <div>
    <div class="request-list">
      <div class="request-search-wrapper">
        <div class="search-box-container">
          <input
            v-model="filterInput"
            class="search-box__input"
            placeholder="Pesquisar..."
          >
          <img
            class="search-box__icon"
            src="/static/images/icon-search-purple.svg"
          >
        </div>

        <div class="request-search__filter-labels">
          <span id="filterLabels">Filtrando por:</span>
          <span class="filter-labels">
            {{ displayedFilter.text }}
          </span>
          <span
            v-if="displayedFilter.rest > 0"
            class="filter-labels"
          >
            + Filtros
          </span>
          <span
            v-if="filterLabels[0] !== 'todas'"
            class="request-search__clear-search"
            @click="clearFilter"
          >
            <md-tooltip
              md-delay="400"
              md-direction="top"
            >Limpar filtros</md-tooltip>
            <img
              src="/static/images/icon-close-alt.svg"
              alt="fechar"
            >
          </span>
        </div>
      </div>
      
      <Alert
        :alert-text="alertSupplies"
        item-name-in-storage="alertSuppliesClosed"
      />

      <div
        v-if="items.length"
        class="request-list__items"
      >
        <div class="request-list__items-head">
          <div class="request-list__id">
            Número
          </div>
          <div class="request-list__date">
            Data do pedido
          </div>
          <div class="request-list__requester">
            Solicitante
          </div>
          <div class="request-list__status-head">
            Status
          </div>
          <div class="request-list__situation-head">
            Situação
          </div>
          <div class="request-list__actions" />
          <div class="request-list__arrow" />
        </div>
        <div
          v-if="!filteredArray.length"
          class="request-list__no-result"
        >
          Nenhum resultado encontrado
        </div>
        <div
          v-for="(item, index) in filteredArray"
          :key="index"
          class="request-list__item"
          :class="{ 'request-list__item-read-only': item.sentForAnalysis }"
          @click="handleClick(item, $event)"
        >
          <!-- {{ item}} -->
          <div class="request-list__id">
            {{ item.number }}
          </div>
          <div class="request-list__date">
            {{ item.createdAt }}
          </div>
          <div class="request-list__requester">
            <div class="request-list__requester-name">
              {{ item.requester }}
            </div>
            <div class="request-list__requester-email">
              {{ item.requesterEmail }}
            </div>
          </div>
          <div
            class="request-list__status"
            :class="classStatus(item.status)"
          >
            {{ item.status }}
          </div>
          <div class="request-list__situation">
            {{ item.situation }}
          </div>
          <div class="request-list__actions ">
            <div class="request-list__actions-container">
              <!-- edit action -->
              <div
                id="edit"
                class="status-icon icon-edit-alt"
                :class="{ 'request-list__item-read-only': item.status !== 'SOLICITADO' }"
              >
                <md-tooltip
                  v-if="item.status === 'SOLICITADO'"
                  md-delay="400"
                  md-direction="top"
                >
                  Editar
                </md-tooltip>
                <md-tooltip
                  v-if="item.status !== 'SOLICITADO'"
                  md-daley="400"
                  md-direction="top"
                >
                  O pedido ja foi enviado para análise
                </md-tooltip>
              </div>
              <!-- delete action -->
              <div
                id="delete"
                class="status-icon icon-delete-alt"
                :class="{'request-list__item-read-only': item.status !== 'SOLICITADO'}"
              >
                <md-tooltip
                  v-if="item.status === 'SOLICITADO'"
                  md-tooltip
                  md-delay="400"
                  md-direction="top"
                >
                  Excluir
                </md-tooltip>
                <md-tooltip
                  v-if="item.status !== 'SOLICITADO'"
                  md-daley="400"
                  md-direction="top"
                >
                  O pedido ja foi enviado para análise
                </md-tooltip>
              </div>
            </div>
          </div>
          <div class="request-list__arrow">
            <img
              src="/static/images/icon-arrow-right.svg"
              alt="seta"
            >
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="items.length === 0"
      class="request-empty"
    >
      <img
        src="/static/images/no-file-img.svg"
        alt="sem-resultados"
      >
      <h3>Nenhum pedido encontrado</h3>
    </div>
    <supplies-delete-modal ref="deleteModal" />
  </div>
</template>

<script>
import fuzzysort from 'fuzzysort'
import SuppliesDeleteModal from './SuppliesDeleteModal.vue'
import Alert from '@/components/common/Alert'
import strings from '@/strings'
import { mapGetters } from 'vuex'
import Moment from 'moment'

export default {
  name: 'RequestList',
  components: { SuppliesDeleteModal, Alert },
  props: {
    items: {
      type: Array,
      default: []
    }
  },
  data: () => ({
    filterInput: '',
    showAlert: true,
    alertSupplies: strings.alerts.alertSupplies,
    filterLabels: []
  }),
  watch: {
    $route (to, from) {
      this.buildFilterLabel()
    },
  },
  methods: {
    classStatus (value) {
      return {
        'finalizado': value === 'FINALIZADO',
        'analise': value === 'EM ANÁLISE',
        'atendimento': value === 'EM ATENDIMENTO',
        'solicitado': value === 'SOLICITADO',
        'logistica': value === 'ENTREGUE À LOGÍSTICA'
      }
    },
    submitAnalyticsEvent (action) {
      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: 'Gestão de Insumos',
        action: action,
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName
      })
    },
    handleClick(item, event) {
      const elemId = event.target.id
      if (elemId === 'delete' && item.status === 'SOLICITADO') {
        this.openDeleteModal(item)
      } else if (elemId === 'edit' && item.status === 'SOLICITADO') {
        this.handleEdit(item)
      } else {
        this.submitAnalyticsEvent('Ver detalhes do pedido')
        this.$router.push({
          name: 'Detalhes do Pedido',
          params: { id: item.number }
        })
      }
    },
    handleEdit(item) {
      if (item.readOnly) return
      this.$router.push({
        name: 'Editar solicitação de insumos',
        params: { id: item.number }
      })
    },
    openDeleteModal(item) {
      if (item.readOnly) return
      this.$refs.deleteModal.openModal(item.number)
    },
    clearFilter () {
      this.$router.replace({'query': null})
      window.location.reload()
    },
    buildFilterLabel () {
      this.filterLabels = []
      let isFiltersEmpty = Object.keys(this.$route.query).length === 0

      if (isFiltersEmpty) {
        this.filterLabels.push('todas')
      }

      if (this.$route.query.status) {
        this.filterLabels.push(...this.$route.query.status.split(',').map(value => value.trim()))
      }

      if (this.$route.query.situations) {
        this.filterLabels.push(...this.$route.query.situations.split(',').map(value => value.trim()))
      }

      if (this.$route.query.startDate && this.$route.query.endDate) {
        this.filterLabels.push(
          Moment(this.$route.query.startDate).format('DD/MM/YYYY') +
          ' até ' +
          Moment(this.$route.query.endDate).format('DD/MM/YYYY')
        )
      }
    }
  },
  computed: {
    ...mapGetters(['profile']),
    filteredArray() {
      let items = this.items
      items.reverse()

      if (this.filterInput) {
        if (this.filterInput.length > 0) {
          let result = fuzzysort.go(this.filterInput, items, {
            keys: ['requester', 'requesterEmail', 'number', 'createdAt'],
            limit: 100,
            allowTypo: true,
            threshold: -10000
          })
          result = result.map(item => {
            item = item.obj
            return item
          })
          return result
        }
      } else {
        return items
      }
    },
    displayedFilter () {
      const text = this.filterLabels.slice(0, 3).join(', ')
      const rest = this.filterLabels.length - 3
      const total  = this.filterLabels.length
      return {
        text, rest, total
      }
    }
  },
  mounted () {
    this.buildFilterLabel()
  }
}
</script>

<style lang="scss">
.request-search {
  &-wrapper {
    display: flex;
    justify-content: space-between;
  }
  &__filter-labels {
    margin-top: 6px;
    .filter-labels {
      color: #7F1A54;
    }
  }
  &__clear-search {
    margin-left: 8px;
    cursor: pointer;
  }
}
.request-list {
  display: block;
  font-size: 14px;
  color: #5a5a5a;

  &__items-head {
    display: flex;
    padding: 8px 17px;

    & > div {
      font-weight: 600;
      color: #999999;
      text-transform: uppercase;
      font-size: 12px;
    }
  }
  &__actions-container {
    & > div {
      &:first-child {
        margin-right: 5px;
      }
    }
  }

  &__item-read-only {
    background-color: #ccc;
    cursor: not-allowed;
    &:hover {
      .request-list__actions-container {
        & > div {
          background-color: #ccc;
          cursor: not-allowed;
        }
      }
    }
  }
  &__status-head {
    width: 20%;
  }
  &__item {
    display: flex;
    background-color: #fff;
    margin-bottom: 8px;
    border-radius: 4px;
    padding: 12px 20px;
    filter: drop-shadow(0px 1px 3px rgba(121, 121, 121, 0.12));
    align-items: center;
    cursor: pointer;

    &:hover {
      filter: drop-shadow(0px 1px 3px rgba(121, 121, 121, 0.12));
      background: linear-gradient(to right, #dd59a5, #dd59a5 4px, #fff 0, #fff 100%);

      div {
        text-decoration: none !important;
      }
      .request-list__actions-container {
        display: flex;
      }
    }

    & > div {
      &:not(.request-list__actions) {
        min-height: 32px;
        display: flex;
        align-items: center;
      }
    }
  }

  &__requester {
    display: flex;
  }
  &__situation {
    width: 15%;
  }
  &__status {
    font-weight: 600;
    position: relative;
    padding-left: 16px;
    width: 20%;
    &::before {
      content: "";
      position: absolute;
      height: 7px;
      width: 7px;
      border-radius: 50%;
      border: 4px solid;
      left: 0;
    }
    &.analise {
      color: #F05253;
    }
    &.finalizado {
      color: #7F1A54;
    }
    &.solicitado {
      color: #F78E26;
    }
    &.logistica {
      color: #EC2072;
    }
    &.atendimento {
      color:#55CD9E;
    }
  }
  &__id {
    width: 12%;
    font-weight: bold;
  }

  &__date {
    width: 15%;
  }

  &__requester {
    width: 22%;
    display: flex;
    flex-wrap: wrap;

    & > div {
      line-height: 1;
      width: 100%;
    }

    &-email {
      color: #999999;
    }
  }

  &__actions-container {
    max-width: 72px;
    & > div {
      width: 32px;
      height: 32px;
    }
  }
  &__actions {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-right: 15px;
    width: calc(15% - 5px);
    align-items: center;

    &-container {
      display: none;
    }
  }
  &__arrow {
    width: 5px;
  }
  .search-box {
    &-container {
      display: flex;
      background-color: white;
      border-radius: 3px;
      padding: 0.5em 0.3em 0.5em 1em;
      margin-right: 1em;
      max-width: 228px;
      margin-bottom: 30px;
    }

    &__input {
      background-color: white;
      border: 0;
      font-family: 'Roboto', sans-serif;
      font-weight: 400;
      color: #4a4a4a;
      min-width: 187px;
      min-height: 19px;

      &::placeholder {
        color: #7a7a7a;
      }

      &:focus {
        border: 0;
        outline: none;
      }
    }
  }
  &__no-result {
    padding: 20px;
    text-align: center;
    color: #999;
  }
}
.request-empty {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  padding: 15vh 0;

  img {
    margin-bottom: 30px;
  }
  h3 {
    font-size: 23px;
    font-weight: normal;
    color: #7a7a7a;
    margin-bottom: 10px;
  }
  p {
    color: #7a7a7a;
    font-size: 16px;
    margin-bottom: 30px;
  }
  h3,
  p {
    width: 100%;
    text-align: center;
  }
  &__btn {
    height: 26px;
    width: 141px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #55cd9e;
    font-size: 11px;
    font-weight: 600;
    font-family: 'Exo 2', sans-serif;
  }

  div#edit {
    margin-right: 5px;
  }
}
</style>
